<template>
    <div class="row productsList-block mt-4">
        <div class="col-xl-12 col-xxl-12 p-lr-0-sm">
            <div class="row multisteps-form">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-lr-0-sm">
                    <div class="multisteps-form__form dis-flex flex-column pos-relative">
                        <div class="row multisteps-form__content pos-absolute top--12rem right-0">
                            <div class="col-sm-12 p-lr-0-sm buttons-whatch-attirute">
                                <div class="pr-3">
                                    <div class="btn small-form-btn alone bar-code fs-10 pointer" title="Product Groups"><i class="fa fa-folder-open fs-11"></i></div>
                                    <div class="btn small-form-btn alone bar-code fs-10 pointer" title="Products List"><i class="uis uis-shopping-bag fs-11"></i></div>
                                    <div class="btn small-form-btn alone fs-10 pointer ml-3" title="Translations Languages">
                                        <select class="translate-lang-swich pointer text-uppercase" name="translation-lang">
                                            <option value="en">en</option><option value="ru">ru</option>
                                            <option value="et">et</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex flex-m flex-sb col-12 p-0">
                                        <div class="dis-flex flex-m dis-none-sm">
                                            <i class="uis uis-filter mr-2 text-rose multi-popup uni txt-normal" desc="Select the desired product location and filter products groups."></i>
                                            <h5 class="text-sm-b">Filter / Search Products</h5>
                                        </div>
                                        <div class="dis-flex flex-m pointer right-0 pos-relative p-0 w-full flex-r col-sm-12 col-md-8 col-lg-7 col-xl-6 col-xxl-5 pl-3 p-lr-0-sm p-l-sm-0-i">
                                            <input class="multisteps-form__input form-control search-form mr-3" type="text" placeholder="Search Product">
                                            <div class="btn small-form-btn bar-code fs-12 pointer mt-0" title="Search Product by Name, SKU, Barcode"><i class="uis uis-search"></i></div>
                                        </div>
                                    </div>
                                    <div class="multisteps-form__content">
                                        <div class="row">
                                            <div class="col-sm-11 col-md-11 p-0 flex-w dis-flex flex-m">
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3 p-lr-0-sm mt-3">
                                                    <label>Category</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected="" disabled="">Choose Category</option>
                                                            <option value="Woman">No Category</option>
                                                            <option value="Woman">Test Category 1</option>
                                                            <option value="Man">Test Category 2</option>
                                                            <option value="Kids">Test Category 3</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3 p-lr-0-sm mt-3">
                                                    <label>Subcategory</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected="" disabled="">Choose Subcategory</option>
                                                            <option value="Woman">Test Subcategory 1</option>
                                                            <option value="Man">Test Subcategory 2</option>
                                                            <option value="Kids">Test Subcategory 3</option>
                                                        </select>
                                                         <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                     </div>
                                                </div>
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3 p-lr-0-sm mt-3">
                                                    <label>Section</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected="" disabled="">Choose Section</option>
                                                            <option value="Woman">Tes Sectiont 1</option>
                                                            <option value="Man">Test Section 2</option>
                                                            <option value="Kids">Test Section 4</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3 p-lr-0-sm mt-3">
                                                    <label>Subsection</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected="" disabled="">Choose Subsection</option>
                                                            <option value="">Test Subsection 1</option>
                                                            <option value="">Test Subsection 2</option>
                                                            <option value="">Test Subsection 3</option>
                                                            <option value="">Test Subsection 4</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dis-flex flex-column flex-r col-sm-1 col-md-1 pl-0 p-lr-0-sm mt-3">
                                                <button class="btn button-create-atrb-btn ml-auto" type="button" title="Filter Products Groups"><i class="uis uis-filter"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="special-header dis-flex flex-column pt-2 pb-2 mb-1 multisteps-form__content col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm flex-sb">
                                    <div class="dis-flex flex-m col-12 p-0">
                                        <div class="dis-flex flex-m flex-w">
                                            <div class="bread-crumbs-products mobile-product-list-card dis-flex flex-m">
                                                <small class="text-capitalize">Cheese</small>
                                                <span class="mr-1 ml-1">/</span>
                                                <small class="text-capitalize">Crunchy Cheese</small>
                                            </div>
                                        </div>
                                        <div class="buttons-whatch-attirute ml-auto">
                                            <div class="dis-flex flex-m">
                                                <template v-if="selectForDelete">
                                                    <div class="buttons-whatch-attirute decline-permission-small">
                                                        <div class="btn small-form-btn bar-code mt-0 pointer" title="Decline Selection" @click="cancelProductSelection()">
                                                            <small class="text-white text-uppercase fs-10 font-p">Decline</small>
                                                        </div>
                                                    </div>
                                                    <div class="buttons-whatch-attirute delete-small-btn ml-3" v-if="isAnyProductIsForDelete()">
                                                        <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Send Product To Trash" @click="sendForDeleteProducts()">
                                                            <i class="uis uis-trash-alt text-white fs-15"></i>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div class="buttons-whatch-attirute give-permission-small" v-else>
                                                    <div class="btn small-form-btn bar-code mt-0 pointer" title="Select Products" @click="selectForDelete = true">
                                                        <small class="text-white text-uppercase fs-10 font-p">Select</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <template v-for="thisProduct in selectedProductList" :key="thisProduct.id">
                                <product-list-item-group v-if="thisProduct.productGroup"
                                    :thisProduct="thisProduct"
                                    :selectedLang="selectedLang"
                                    :selectForDelete="selectForDelete"
                                    @setSelectedProductForOverview="(productID) => {
                                        $emit('update:selectedProductForOverview', productID)
                                        $emit('update:selectedMenu', `productOverview`)
                                    }"></product-list-item-group>
                                <product-list-item v-else
                                    :thisProduct="thisProduct"
                                    :selectedLang="selectedLang"
                                    :selectForDelete="selectForDelete"
                                    @setSelectedProductForEdit="(productID) => {
                                        $emit('update:selectedProductForEdit', productID)
                                        $emit('update:selectedMenu', `productEdit`)
                                    }"></product-list-item>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import productListItemGroupVue from './productListItemGroup.vue';
import productListItemVue from './productListItem.vue';

export default {
    props: {
        selectedProductForOverview: {
            type: [Number, String, null],
            required: true,
        },
        selectedMenu: {
            type: String,
            required: true,
        }
    },
    components: {
        productListItemGroup: productListItemGroupVue,
        productListItem: productListItemVue,
    },
    data() {
        return {
            selectedLang: 'en',
            selectForDelete: false,
            selectedProductList: [],
            selectedProductPage: 1,
        }
    },
    mounted() {
        // this.selectedProductList.push({
        //     id: 1,
        //     productGroup: true,
        //     name: {
        //         en: 'Crunchy Cheese',
        //         ru: 'Crunchy Cheese',
        //     },
        //     selectedForDelete: false,
        //     selectedProductMenu: 'attributes',
        //     photoViewType: 'row',
        //     mainPhoto: 'https://www.officeday.lv/images/z1/450-21609/crisp-cheese-top-food-hrumm-hrumm-039-cream-and-onion-039-35g.jpg'
        // })
        this.selectedProductList.push({
            id: 14,
            name: {
                en: 'Cheese Braid Fresh',
                ru: 'Cheese Braid Fresh',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://www.officeday.lv/images/1/450-21610/fresh-cheese-top-food-cecil-quot-siera-bize-quot-150g.jpg'
        })
        this.selectedProductList.push({
            id: 15,
            name: {
                en: 'Cheese Braid Smoked',
                ru: 'Cheese Braid Smoked',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://www.officeday.lv/images/1/450-21617/smoked-cheese-top-food-cecil-quot-the-right-cheese-braid-quot-150g.jpg'
        })
        this.selectedProductList.push({
            id: 2,
            name: {
                en: 'Crunchy Cheese',
                ru: 'Crunchy Cheese',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://www.officeday.lv/images/z1/450-21609/crisp-cheese-top-food-hrumm-hrumm-039-cream-and-onion-039-35g.jpg'
        })
        this.selectedProductList.push({
            id: 3,
            name: {
                en: 'Crunchy Cheese',
                ru: 'Crunchy Cheese',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://img.esanitex.net/image/0c3db266-190d-4357-a2a4-c3137263a533.jpg?auto=format&amp;fm=avif&amp;w=320'
        })
        // this.selectedProductList.push({
        //     id: 4,
        //     productGroup: true,
        //     name: {
        //         en: 'Crunchy Cheese',
        //         ru: 'Crunchy Cheese',
        //     },
        //     selectedForDelete: false,
        //     selectedProductMenu: 'attributes',
        //     photoViewType: 'row',
        //     mainPhoto: 'https://www.officeday.lv/images/z1/450-21609/crisp-cheese-top-food-hrumm-hrumm-039-cream-and-onion-039-35g.jpg'
        // })
        this.selectedProductList.push({
            id: 5,
            name: {
                en: 'Crunchy Cheese',
                ru: 'Crunchy Cheese',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://img.esanitex.net/image/464c685e-f0ce-4a98-97bf-86dafd099970.jpg?auto=format&amp;fm=avif&amp;w=320'
        })
        // this.selectedProductList.push({
        //     id: 6,
        //     productGroup: true,
        //     name: {
        //         en: 'Crunchy Cheese',
        //         ru: 'Crunchy Cheese',
        //     },
        //     selectedForDelete: false,
        //     selectedProductMenu: 'attributes',
        //     photoViewType: 'row',
        //     mainPhoto: 'https://www.officeday.lv/images/z1/450-21609/crisp-cheese-top-food-hrumm-hrumm-039-cream-and-onion-039-35g.jpg'
        // })
        // this.selectedProductList.push({
        //     id: 7,
        //     productGroup: true,
        //     name: {
        //         en: 'Crunchy Cheese',
        //         ru: 'Crunchy Cheese',
        //     },
        //     selectedForDelete: false,
        //     selectedProductMenu: 'attributes',
        //     photoViewType: 'row',
        //     mainPhoto: 'https://www.officeday.lv/images/z1/450-21609/crisp-cheese-top-food-hrumm-hrumm-039-cream-and-onion-039-35g.jpg'
        // })
        this.selectedProductList.push({
            id: 8,
            name: {
                en: 'Crunchy Cheese',
                ru: 'Crunchy Cheese',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://img.esanitex.net/image/10d79627-c959-422e-8128-5dfaa1ea86d3.jpg?auto=format&amp;fm=avif&amp;w=320'
        })
        // this.selectedProductList.push({
        //     id: 9,
        //     productGroup: true,
        //     name: {
        //         en: 'Crunchy Cheese',
        //         ru: 'Crunchy Cheese',
        //     },
        //     selectedForDelete: false,
        //     selectedProductMenu: 'attributes',
        //     photoViewType: 'row',
        //     mainPhoto: 'https://www.officeday.lv/images/z1/450-21609/crisp-cheese-top-food-hrumm-hrumm-039-cream-and-onion-039-35g.jpg'
        // })
        this.selectedProductList.push({
            id: 10,
            name: {
                en: 'Crunchy Cheese',
                ru: 'Crunchy Cheese',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://img.esanitex.net/image/8a49d114-224b-4724-85ba-02a4bbbd1504.jpg?auto=format&amp;fm=avif&amp;w=320'
        })
        this.selectedProductList.push({
            id: 11,
            name: {
                en: 'Crunchy Cheese',
                ru: 'Crunchy Cheese',
            },
            selectedForDelete: false,
            selectedProductMenu: 'info',
            photoViewType: 'row',
            mainPhoto: 'https://img.esanitex.net/image/91d1ff14-d7bb-48d6-a130-d9fe8a7f0d14.jpg?auto=format&amp;fm=avif&amp;w=320'
        })
    },
    methods: {
        cancelProductSelection: function() {
            this.selectForDelete = false;
            this.selectedProductList.forEach(thisProduct => {
                if (thisProduct.selectedForDelete) {
                    thisProduct.selectedForDelete = false;
                }
            });
        },
        sendForDeleteProducts: function() {
            this.selectForDelete = false;
            let selectedProductsForDelete = [];
            this.selectedProductList.forEach(thisProduct => {
                if (thisProduct.selectedForDelete) {
                    selectedProductsForDelete.push(thisProduct.id)
                    thisProduct.selectedForDelete = false;
                }
            })
            console.log(selectedProductsForDelete)
        },
        isAnyProductIsForDelete() {
            let isAnyProductIsForDelete = false
            for (const key in this.selectedProductList) {
                if (this.selectedProductList[key].selectedForDelete) {
                    isAnyProductIsForDelete = true
                    break
                }
            }

            return isAnyProductIsForDelete
        }
    }
}
</script>

<style>

</style>